import {
  IconButton,
  Row,
  LabeledInput,
  LabeledTextarea,
  ResponsiveOverlay,
} from 'components/Blocks';
import { RefreshIcon } from 'components/Icons';

import SyncClientBilling from './Sync';

import { useClient } from '../OptionsContext';
import { useToggleV2 } from 'hooks';

import { loaders } from 'entities';

interface BillingProps {
  children?: never;
  open: boolean;
  close(): void;
}

function Billing({ close, open }: BillingProps) {
  const { selectedClient } = useClient();

  const [notFound, notFoundHandlers] = useToggleV2();

  const billing = loaders.clients.billing.use({
    params: { id: selectedClient?.id as string },

    blockLoad: !selectedClient,

    onDataChange: notFoundHandlers.turnOff,

    onError({ response }) {
      if (response?.status === 404) notFoundHandlers.turnOn();
    },
  });

  const showMessage = billing.error;

  const message = notFound ? 'BILLING_INFO_MISSING' : '#ERROR';

  const loading = billing.loading;

  return (
    <ResponsiveOverlay
      className="w-full overflow-y-auto"
      title={`Billing info - ${selectedClient?.name ?? ''}`}
      isOpen={open}
      close={close}
      preventOpenAutoFocus
    >
      <LabeledInput
        label="Preferred Currency"
        value={showMessage ? message : billing.data?.preferredCurrency}
        disabled
        loading={loading}
      />

      <LabeledInput
        label="Billing Company Name"
        value={showMessage ? message : billing.data?.companyName}
        disabled
        loading={loading}
        name="companyName"
      />

      <LabeledInput
        label="Billing Preferred Due Date"
        value={showMessage ? message : billing.data?.preferredDueDate}
        disabled
        loading={loading}
        name="preferredDueDate"
      />

      <LabeledTextarea
        label="Billing Contact Details"
        value={showMessage ? message : billing.data?.contactDetails}
        disabled
        loading={loading}
        name="contactDetails"
      />

      <LabeledTextarea
        label="Billing Emails"
        value={showMessage ? message : billing.data?.emails.join('\n')}
        disabled
        loading={loading}
        name="emails"
      />

      <LabeledTextarea
        label="Billing Comments"
        value={showMessage ? message : billing.data?.comment}
        disabled
        loading={loading}
        name="comment"
      />

      <Row justifyContent="space-between">
        <IconButton onClick={billing.retry} tooltipContent="Reload Data">
          <RefreshIcon />
        </IconButton>

        <SyncClientBilling save={billing.overwrite} />
      </Row>
    </ResponsiveOverlay>
  );
}

export default Billing;
